//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SheetMetal.JoggleInputListItemBuilderList.js";
import "../Features/Features.SheetMetal.JoggleSideOptionsBuilder.js";
import "../no/Expression.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"Adjustment",0,"Expression",0],[0,"EndPlane",1,"Plane",0],[0,"FlatPatternCompensation",1,0],[1,"InputList",0,"Features.SheetMetal.JoggleInputListItemBuilderList",0],[0,"LimitType",1,0],[1,"Side1Options",0,"Features.SheetMetal.JoggleSideOptionsBuilder",0],[1,"Side2Options",0,"Features.SheetMetal.JoggleSideOptionsBuilder",0],[0,"StartPlane",1,"Plane",0],[0,"SymmetricSides",1,0],[0,"UseMaterialTable",1,0]],[[[],"CreateJoggleInputListItem",{R_:{listitem:"Features.SheetMetal.JoggleInputListItemBuilder"}},0,0]],[]];
SPLM.Features.SheetMetal.JoggleBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.JoggleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.JoggleBuilder.LimitTypes = Object.freeze({
    "Single" : "Single", "Twin" : "Twin"});

export default SPLM;